import { Component, Input } from '@angular/core';

@Component({
    selector: 'pdp-product-availability-notification-gold-message',
    templateUrl: './product-availability-notification-gold-message.component.html',
    styleUrls: ['./product-availability-notification-gold-message.component.scss'],
    standalone: false
})
export class ProductAvailabilityNotificationGoldMessageComponent {

	@Input()
	public isPanelText: boolean;

	@Input()
	public showDetailsLink: boolean;

	public detailsLink = '/s/scorecard-benefits';

}
